// extracted by mini-css-extract-plugin
export default {"container":"IV-z","title":"JV-z","link":"KV-z"};